export class ProfileFilters {
  name: string;
  from: number;
  until: number;
  permission: string;
}
